import { GriddedItem, GridLayout, GridState } from "./grid";
import { cloneWidthHeight } from "./helpers";

type Column = {
	top: number,
	left: number
};

export default function dynamicGridder(items: HTMLElement[], state: GridState): GridLayout {
	let itemList: GriddedItem[] = [];

	let columnCount = state.gridColumns || 4;
	let marginX = state.gridSpacingXPx || 0;
	let marginY = state.gridSpacingYPx || 0;
	let combinedXMargins = marginX * (columnCount-1);
	let columnWidth = (state.containerWidth - combinedXMargins) / columnCount;

	// Initiate columns
	let columns = [];
	for (let i=0; i<columnCount; i++) {
		columns[i] = {
			top: 0,
			bottom: 0,
			left: i*(columnWidth+marginX)
		}
	}

	for (let i=0; i<items.length; i++) {
		let item = items[i];
		let itemDimensions = cloneWidthHeight(item, {
			width: columnWidth + 'px'
		});
		let itemWidthHeightRatio = itemDimensions.width === 0 ? 1 : (itemDimensions.width / itemDimensions.height);
		let itemWidth = columnWidth;
		let itemHeight = columnWidth / itemWidthHeightRatio; 
		let column = nextColumn();
		itemList.push({
			DOM: item,
			css: {
				top: column.top,
				left: column.left,
				width: itemWidth,
				height: itemHeight
			}
		});
		column.top += itemHeight + marginY;
	}

	function nextColumn() {
		let bestColumn: Column;
		for (let i=0; i<columnCount; i++) {
			if (!bestColumn || columns[i].top < bestColumn.top) {
				bestColumn = columns[i];
			}
		}
		return bestColumn;
	}

	let gridHeight = 0;
	for (let i=0; i<columnCount; i++) {
		if (columns[i].top > gridHeight) {
			gridHeight = columns[i].top;
		}
	}

	return {
		itemList: itemList,
		height: Math.max(0, gridHeight-marginY)
	};

};
